<template>
    <Menu ref="shop" @on-select="selectMenu" class="menu" mode="horizontal" theme="light" :active-name="active">
        <MenuItem v-for="(menu,index) in menuList" :key="index" :name="menu.path.slice(1)">
            <Icon class="menuTitle" :type="menu.icon" />
            <span class="menuTitle">{{menu.name}}</span>
        </MenuItem>
    </Menu>
</template>

<script>
export default {
    data(){
        return{
            siderList : [],
            active:"ImageCenter"
        }
    },
    methods:{
        selectMenu(name){
            this.$router.push('/'+name)
        }
    },
    computed:{
        menuList(){
            let arr = JSON.parse(window.sessionStorage.getItem('tree'))
            arr.push({
                path: '/ClassicCase',
                icon: '',
                name: '典型病例'
            })
            arr.push({
                path: '/Video',
                icon: '',
                name: '影像课程视频'
            })
            arr.push({
                path: '/File',
                icon: '',
                name: '课件资源'
            })
            return arr
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.active=this.$route.path.slice(1).split('/')[0]
            this.$refs.shop.updateActiveName()
        })
    }
}
</script>

<style lang="scss" scoped>
    .menu{
        background: rgb(45, 140, 240);
        
    }
    .menuTitle{
        color: white;
    }
    .ivu-menu-item-selected{
        background: white;
        .menuTitle{
            color: rgb(45, 140, 240);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Header/ItHeaderMenu.vue